import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=3a8389fc&scoped=true&"
import script from "./Source.vue?vue&type=script&lang=js&"
export * from "./Source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8389fc",
  null
  
)

export default component.exports